import { JSONable } from '$/entities/lib/JSONable';

export type Preference = boolean | null;

/**
 * Base class for keeping track of various user preferences, eg: email notifications.
 * It is intended to be used as a class for the JSON Column in the DB.
 */
export default class BasePreferences extends JSONable {

	constructor(initialValues?: Dictionary<any>) {
		super();

		_.forEach(initialValues, (value, key) => {
			this[key] = value;
		});
	}

	/**
	 * @returns a list of preferences available
	 */
	static getAvailablePreferences(): string[] {
		return this.getFields();
	}

}
